<template>
    <v-layout row wrap class="section-title text-justify my-5">
      <v-flex xs12 class="text-xs-center">
        <h2 class="word-one">{{ title }}</h2>
          <div class="divider-header"></div>
      </v-flex>
    </v-layout>
</template>

<script>
     export default {
         name: 'SectionTitle',
         props: ['title']
     }
</script>
